import * as fromDatatype from "../datatype-library";

export interface bl_fi_entity_purchase_credit_terms_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  entity_credit_terms_guid: fromDatatype.GuidDataFieldInterface;
  credit_terms_code: fromDatatype.VarcharDatatypeInterface;
  credit_terms_name: fromDatatype.VarcharDatatypeInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  credit_terms_set_year: fromDatatype.IntegerDatatypeInterface;
  credit_terms_set_month: fromDatatype.IntegerDatatypeInterface;
  credit_terms_set_day: fromDatatype.IntegerDatatypeInterface;
  credit_terms_add_year: fromDatatype.IntegerDatatypeInterface;
  credit_terms_add_month: fromDatatype.IntegerDatatypeInterface;
  credit_terms_add_day: fromDatatype.IntegerDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  credit_term_logic: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_entity_purchase_credit_terms_RowClass
  implements bl_fi_entity_purchase_credit_terms_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  entity_credit_terms_guid: fromDatatype.GuidDataFieldInterface;
  credit_terms_code: fromDatatype.VarcharDatatypeInterface;
  credit_terms_name: fromDatatype.VarcharDatatypeInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  credit_terms_set_year: fromDatatype.IntegerDatatypeInterface;
  credit_terms_set_month: fromDatatype.IntegerDatatypeInterface;
  credit_terms_set_day: fromDatatype.IntegerDatatypeInterface;
  credit_terms_add_year: fromDatatype.IntegerDatatypeInterface;
  credit_terms_add_month: fromDatatype.IntegerDatatypeInterface;
  credit_terms_add_day: fromDatatype.IntegerDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  credit_term_logic: fromDatatype.VarcharDatatypeInterface;
}
